import styled from 'styled-components'

export const Container = styled.div`
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0;
`

export const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: none;
  border: none;
  width: 90%;
  margin: 0 10px;
  min-height: 100%;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`

export const Header = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f3f4f6;
`

export const UserName = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

export const AssociationBadge = styled.div<{ $status: string }>`
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  background: ${(props) => {
    switch (props.$status) {
      case 'active':
        return '#DEF7EC'
      case 'pending':
        return '#FEF3C7'
      case 'inactive':
        return '#F3F4F6'
      case 'expired':
        return '#FEE2E2'
      default:
        return '#F3F4F6'
    }
  }};
  color: ${(props) => {
    switch (props.$status) {
      case 'active':
        return '#03543F'
      case 'pending':
        return '#92400E'
      case 'inactive':
        return '#6B7280'
      case 'expired':
        return '#991B1B'
      default:
        return '#6B7280'
    }
  }};
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
`

export const InfoLabel = styled.span`
  font-size: 1rem;
  font-weight: 400;
  color: #3d3d3d;
`

export const InfoValue = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`

export const ErrorContainer = styled.div`
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  padding: 1rem;
  color: #991b1b;
  text-align: center;
`

export const WarningCard = styled.div`
  background: #fff;
  border: 2px solid #02b0bb;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 8px rgba(251, 191, 36, 0.2);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const WarningIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fbbf24;
  color: white;
  flex-shrink: 0;
  font-size: 1.5rem;
  font-weight: bold;
`

export const WarningContent = styled.div`
  flex: 1;

  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #3d3d3d;
    margin: 0 0 0.5rem 0;
  }

  p {
    font-size: 0.875rem;
    color: #3d3d3d;
    margin: 0;
    line-height: 1.5;
  }
`

export const WarningAmount = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: #3d3d3d;
  margin-right: 1rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-top: 0.5rem;
  }
`

export const PayAssociationButton = styled.button`
  background: #fff;
  color: #3d3d3d;
  border: 1px solid #02b0bb;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #02b0bb;
    color: #fff;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
